/** Tri naturel des libellés de lieux / chambres (Chambre 2 avant Chambre 10). */
export function comparePlaceLabels(a: string, b: string): number {
  return a.localeCompare(b, 'fr', { numeric: true, sensitivity: 'base' });
}

export function getPlaceSortLabel(place: {
  display_name?: string | null;
  name?: string | null;
}): string {
  return (place.display_name || place.name || '').trim();
}

export function comparePlacesByLabel(
  a: { display_name?: string | null; name?: string | null },
  b: { display_name?: string | null; name?: string | null }
): number {
  return comparePlaceLabels(getPlaceSortLabel(a), getPlaceSortLabel(b));
}
